"use strict";

export default function sleep(time) {
	return new Promise(resolve => setTimeout(resolve, time));
}


// WEBPACK FOOTER //
// ./~/vwa/sleep.js